<app-reservation-detail
        [reservationId]="reservationId"
        (closeClick)="closeClicked($event)"
        (reservationUpdated)="reservationChanged($event)"
        [reservationToClone]="reservationToClone"
        [isNewReservationFromCalendar]="isNewReservationFromCalendar"
        (returnGift)="returnToGift()"
        [byGift]="byGift"
        [isTourOperator]="isTourOperator"
        mat-dialog-content
></app-reservation-detail>